// extracted by css-extract-rspack-plugin
module.exports =  {"weatherDayForecast":"puC1t","iconWrap":"ytNf5","secItems":"jolbV","secItemCol":"DsA2M","valueText":"No4Kt","tepmWrap":"OBMNq"};